<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommon from './mixin';
import addonCustomSelect from '@/plans/mx/addonCustomSelect';
import { ADDON_GROUP } from '@/common/constants';
import { softBundleUtils } from '@/views/config/soft-bundle/helper';

export default {
  name: 'ZoomClipsAddon',
  mixins: [base, planCommon,addonCustomSelect],
  for: () => {
    return softBundleUtils.isSimilarPbxBundle() &&
    (window.$context?.is?.buyNow || window.$context?.is?.basic2pro);
  },
  group(){
    return [ADDON_GROUP.WIN_BACK, undefined];
  }
};
</script>
